<template>
  <div class="exhibition-board-container">
    <div class="tip"><span class="dot"></span>根据站点类型，点击下方卡片进行站点创建</div>

    <div class="card-box-container">
      <Card v-for="(info, index) in classesList" :key="index" :info="info"></Card>
    </div>
  </div>
</template>

<script>
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { onHttpResponseSilent } from '@/utils/request'
import { querySpiderListApi } from '@/api/Site/Manage'
import { querySpiderApiListApi } from '@/api/Site/Manage'
import { querySpiderTwitterListApi } from '@/api/Site/Manage'
import { querySpiderDocListApi } from '@/api/Site/Manage'
import { getApprovalMeNewsListApi, getApprovalMeNoNewsListApi } from '@/api/Site/Approval'


import Card from './Card'

const Done_Type_List = [
  'news',
  'api', // 云采集
  'wechat', // 微信公众号
  'document', // 文献

  // 'twitter',
  // 'weibo',
  // 'facebook',
  // 'youtube',
  // 'toutiao',
  // 'tg',
  // 'ins',
  // 'vk',
]

export default {
  components: {
    Card
  },
  data() {
    return {
      classesList: []
    }
  },

  created() {
    this.querySpiderClassInfo()
  },

  methods: {
    querySpiderClassInfo() {
      querySpiderClassInfoApi()
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          let list = Done_Type_List.map((item) => {
            let temp = null
            data.forEach((inner) => {
              if (item === inner.type) {
                temp = inner
              }
            })
            return temp
          })
          this.getDetailList(list)
        })
    },

    getDetailList(infoList) {
      let _classesPromiseList = infoList.map((info) => {
        switch (info.type) {
          case 'news':
            return this.getNewsList(info)

          case 'weibo':
          case 'facebook':
          case 'tg':
          case 'ins':
          case 'vk':
          case 'twitter':
          case 'youtube':
            return this.getWeMedia(info)
          case 'toutiao':
          case 'api':
            return this.getApi(info)
          case 'document':
            return this.getDocumentList(info)
          case 'wechat':
            return this.getWechat(info)
          default:
            return Promise.resolve({ info, data: [] })
        }
      })
      Promise.all(_classesPromiseList).then((data) => {
        this.classesList = data.filter((d) => Done_Type_List.includes(d.info.type))
      })
    },

    getDocumentList(info) {
      return new Promise((resolve) => {
        getApprovalMeNoNewsListApi({ spiderClassId:info.spiderClassId, pn: 1, pageSize: 12, spiderClassId: info.spiderClassId })
          .then(onHttpResponseSilent)
          .then(({ data }) => {
            resolve({ info, data })
          })
          .catch(() => {
            resolve({ info, data: [] })
          })
      })
    },

    getNewsList(info) {
      return new Promise((resolve) => {
        getApprovalMeNewsListApi({ spiderClassId:info.spiderClassId,  pn: 1, pageSize: 12 })
          .then(onHttpResponseSilent)
          .then(({ data }) => {
            resolve({ info, data })
          })
          .catch(() => {
            resolve({ info, data: [] })
          })
      })
    },

    getApi(info) {
      return new Promise((resolve) => {
        getApprovalMeNoNewsListApi({ spiderClassId:info.spiderClassId, pn: 1, pageSize: 12, spiderClassId: info.spiderClassId })
          .then(onHttpResponseSilent)
          .then(({ data }) => {
            resolve({ info, data })
          })
          .catch(() => {
            resolve({ info, data: [] })
          })
      })
    },

    getWeMedia(info) {
      return new Promise((resolve) => {
        getApprovalMeNoNewsListApi({ pn: 1, pageSize: 12, spiderClassId: info.spiderClassId })
          .then(onHttpResponseSilent)
          .then(({ data }) => {
            resolve({ info, data })
          })
          .catch(() => {
            resolve({ info, data: [] })
          })
      })
    },

    getWechat(info) {
      return new Promise((resolve) => {
        getApprovalMeNoNewsListApi({ pn: 1, pageSize: 12, spiderClassId: info.spiderClassId })
          .then(onHttpResponseSilent)
          .then(({ data }) => {
            resolve({ info, data })
          })
          .catch(() => {
            resolve({ info, data: [] })
          })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.exhibition-board-container {
  padding: 35px;
  .dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #3c93ff;
    border-radius: 50%;
    margin-right: 10px;
  }

  .tip {
    color: #333;
    margin-bottom: 30px;
  }

  .card-box-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 30px;
  }
}
</style>
